export * from "./posthogClient";
